import React from "react";

import { Calendar as CalendarIcon } from "react-feather";
import pluralize from "pluralize";

import { Avatar, Card, Typography, makeStyles } from "@material-ui/core";

import Label from "@ds-developer/label";
import PortletTitle from "@ds-developer/portlet-title";

import CardSkeleton from "../Skeleton";

import { TodaysLessonsProps } from "./types";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3, 2),
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    maxHeight: "96px",
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    height: 48,
    width: 48,
  },
  nextLessonTimeLabel: {
    marginTop: "6px",
    [theme.breakpoints.up("md")]: {
      marginTop: "10px",
    },
  },
}));

const TodaysLessons: React.FC<TodaysLessonsProps> = ({
  loading = false,
  nextLessonTime,
  numberOfLessons,
}) => {
  const classes = useStyles();

  return loading ? (
    <CardSkeleton />
  ) : (
    <Card className={classes.root}>
      <PortletTitle title="Today's lessons">
        <Typography
          variant="subtitle1"
          component="span"
          color="textPrimary"
          data-test="number-of-lessons-text"
        >
          {numberOfLessons
            ? pluralize("lesson", numberOfLessons, true)
            : "0 lessons"}
        </Typography>
      </PortletTitle>
      {nextLessonTime && (
        <PortletTitle title="Next">
          <Label
            className={classes.nextLessonTimeLabel}
            color="success"
            data-test="next-lesson-time-text"
          >
            {nextLessonTime}
          </Label>
        </PortletTitle>
      )}
      <Avatar className={classes.avatar} color="secondary">
        <CalendarIcon />
      </Avatar>
    </Card>
  );
};

export default TodaysLessons;
